import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const api = {
  // Vehicles
  getVehicles: async (params = {}) => {
    const response = await axios.get(`${API}/vehicles`, { params });
    return response.data;
  },

  getVehicle: async (id) => {
    const response = await axios.get(`${API}/vehicles/${id}`);
    return response.data;
  },

  createVehicle: async (data) => {
    const response = await axios.post(`${API}/vehicles`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  updateVehicle: async (id, data) => {
    const response = await axios.put(`${API}/vehicles/${id}`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  deleteVehicle: async (id, permanent = false) => {
    const response = await axios.delete(`${API}/vehicles/${id}?permanent=${permanent}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  emptyTrash: async () => {
    const response = await axios.post(`${API}/vehicles/empty-trash`, {}, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Categories
  getCategories: async () => {
    const response = await axios.get(`${API}/categories`);
    return response.data;
  },

  createCategory: async (data) => {
    const response = await axios.post(`${API}/categories`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  updateCategory: async (id, data) => {
    const response = await axios.put(`${API}/categories/${id}`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  deleteCategory: async (id) => {
    const response = await axios.delete(`${API}/categories/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Filters
  getFilters: async () => {
    const response = await axios.get(`${API}/filters`);
    return response.data;
  },

  // Upload
  uploadImages: async (files) => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    
    const response = await axios.post(`${API}/upload`, formData, {
      headers: {
        ...getAuthHeader(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  uploadVideo: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await axios.post(`${API}/upload-video`, formData, {
      headers: {
        ...getAuthHeader(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  parseYoutubeUrl: async (url) => {
    const formData = new FormData();
    formData.append('url', url);
    
    const response = await axios.post(`${API}/parse-youtube`, formData, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Stats
  getStats: async () => {
    const response = await axios.get(`${API}/stats`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Settings
  getSettings: async () => {
    const response = await axios.get(`${API}/settings`);
    return response.data;
  },

  updateSettings: async (data) => {
    const response = await axios.put(`${API}/settings`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Vehicle count (lightweight)
  getVehiclesCount: async (params = {}) => {
    const response = await axios.get(`${API}/vehicles/count`, { params });
    return response.data;
  },

  // Seed
  seedData: async () => {
    const response = await axios.post(`${API}/seed`);
    return response.data;
  }
};

export const formatPrice = (price) => {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
};

export const formatWhatsAppLink = (number, message) => {
  const cleanNumber = number.replace(/\s/g, '');
  const fullNumber = cleanNumber.startsWith('52') ? cleanNumber : `52${cleanNumber}`;
  const encodedMessage = encodeURIComponent(message);
  return `https://api.whatsapp.com/send?phone=${fullNumber}&text=${encodedMessage}`;
};
